import type { ReactNode } from 'react'

import cn from 'classnames'

import { configuration } from 'mmfintech-checkout-commons'
import { getPaymentMethodImageUrl } from 'mmfintech-commons'

import './methodImage.scss'

interface MethodImageProps {
  method: string
  className?: string
  children?: ReactNode
}

const MethodImage = ({ method, className, children }: MethodImageProps) => (
  <span className={cn('method-image-wrapper', className)}>
    {<img src={`${configuration.readBackendConfig()}${getPaymentMethodImageUrl(method)}`} alt='' />}
    {children}
  </span>
)

export default MethodImage
